import { type ReactNode } from 'react';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import styles from './HoverTooltip.module.css';

export interface IHoverTooltipProps {
  /** The element that triggers the tooltip on hover. */
  children: ReactNode;
  /** The content rendered inside the navy popup. */
  content: ReactNode;
}

/**
 * Instant, multi-section hover popup for the activity cards — a preset over
 * `ui/Tooltip`'s marker variant (see frontend/CLAUDE.md), keeping only the
 * trigger wrapper and the section layout its callers rely on.
 */
export function HoverTooltip({ children, content }: IHoverTooltipProps) {
  return (
    <Tooltip variant="marker" wrap delay={0} sideOffset={6} content={content}>
      <span className={styles.triggerWrapper}>{children}</span>
    </Tooltip>
  );
}

export { styles as hoverTooltipStyles };
